import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

const getBottomPadding = (compact, createStep) => {
  if (compact) {
    return 16;
  }
  if (createStep) {
    return 52;
  }
  return 84;
};

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${theme.color.white};
  background: ${({ background }) =>
    background
      ? `${theme.color.white} url(${background}) top right no-repeat`
      : theme.color.white};
  background-size: contain;
  width: 620px;
  min-height: 593px;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0);
  border-radius: 8px;
  /* to make colored children obey border-radius */
  overflow: hidden;
`;

export const Content = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding-bottom: ${({ compact, createstep }) =>
    getBottomPadding(compact, createstep)}px;
`;

export const Header = styled('div')`
  display: flex;
  flex: none;
  height: 72px;
  width: 596px;
  border-top-left-radius: ${theme.borderRadius.large};
  border-top-right-radius: ${theme.borderRadius.large};
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  align-self: center;
  font-weight: 500;
  font-size: 16px;
`;

export const Footer = styled('div')`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  width: 596px;
  border-bottom-left-radius: ${theme.borderRadius.large};
  border-bottom-right-radius: ${theme.borderRadius.large};
  border-top: 1px solid ${theme.color.grayLight};
  background-color: #fff;
  padding-left: 12px;
  padding-right: 12px;
`;

export const SuccessFooter = styled('div')`
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding-bottom: 36px;
`;

export const Button = styled('button')`
  border-radius: ${theme.borderRadius.medium};
  border: none;
  padding: 6px 16px;
  background-color: ${({ primary }) =>
    primary ? theme.color.purple : theme.color.beige};
  color: ${({ primary }) => (primary ? theme.color.white : theme.color.black)};
  font-size: 14px;
  font-weight: ${theme.font.weight.medium};
  letter-spacing: 0;
  line-height: 20px;
  cursor: pointer;
  font-family: ${theme.font.family.workSans};
  transition: background-color ${theme.transition.speed.xFast}
    ${theme.transition.easing.easeOut};

  :hover {
    background-color: ${({ primary }) =>
      primary ? theme.color.purple0 : theme.color.beige};
  }
`;

export const UnstyledButton = styled('div')`
  display: flex;
  color: ${theme.color.purple};
  font-family: ${theme.font.family.workSans};
  font-size: 12px;
  cursor: pointer;
`;

export const CloseButton = styled('div')`
  width: 48px;
  height: 48px;
  border-radius: ${theme.borderRadius.medium};
  color: ${theme.color.purple};
  background-color: rgba(133, 67, 192, 0.08);
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 16px;
  transition: background-color ${theme.transition.speed.xFast}
    ${theme.transition.easing.easeOut};

  &:hover {
    background-color: rgba(133, 67, 192, 0.2);
  }

  &:active {
    background-color: rgba(133, 67, 192, 0.08);

    svg {
      opacity: 0.56;
    }
  }
`;

export const Stepper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 70px;
`;

export const Step = styled('div')`
  width: 30px;
  height: 4px;
  border-radius: ${theme.borderRadius.small};
  background-color: ${({ active }) =>
    active ? theme.color.purple : theme.color.gray};
`;

export const ModalTitle = styled('h2')`
  font-weight: 500;
  font-size: 16px;
  margin: 0;
`;

export const Title = styled('h3')`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.headline};
  font-weight: bold;
  line-height: 28px;
  margin: 0 0 24px;
  color: ${theme.color.mediumBlue};
`;

export const Text = styled('div')`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.large};
  font-weight: normal;
  line-height: 24px;
  margin-bottom: 24px;
  color: ${theme.color.mediumBlue};
`;

export const BackButtonPlaceholder = styled('div')`
  width: 65px;
`;
